export default [
  {
    key: 'meronPayoutRatio',
    label: 'field.meronPayoutRatio',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'meron',
    cols: 2,
  },
  {
    key: 'lowerMeronPayout',
    label: 'field.lowerMeronPayout',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'meron',
    cols: 2,
  },
  {
    key: 'higherMeronPayout',
    label: 'field.higherMeronPayout',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'meron',
    cols: 2,
  },
  {
    key: 'walaPayoutRatio',
    label: 'field.walaPayoutRatio',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'wala',
    cols: 2,
  },
  {
    key: 'lowerWalaPayout',
    label: 'field.lowerWalaPayout',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'wala',
    cols: 2,
  },
  {
    key: 'higherWalaPayout',
    label: 'field.higherWalaPayout',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'wala',
    cols: 2,
  },
  {
    key: 'meronBetTotal116',
    label: 'field.rielMeronBet',
    rules: '',
    type: 'currency',
    class: 'meron',
    disabled: true,
    cols: 2,
  },
  {
    key: 'meronBetTotal840',
    label: 'field.dollarMeronBet',
    rules: '',
    type: 'currency',
    class: 'meron',
    disabled: true,
    cols: 2,
  },
  {
    key: 'meronBetTotal764',
    label: 'field.thaiMeronBet',
    rules: '',
    type: 'currency',
    class: 'meron',
    disabled: true,
    cols: 2,
  },
  {
    key: 'walaBetTotal116',
    label: 'field.rielWalaBet',
    rules: '',
    type: 'currency',
    class: 'wala',
    disabled: true,
    cols: 2,
  },
  {
    key: 'walaBetTotal840',
    label: 'field.dollarWalaBet',
    rules: '',
    type: 'currency',
    class: 'wala',
    disabled: true,
    cols: 2,
  },
  {
    key: 'walaBetTotal764',
    label: 'field.thaiWalaBet',
    rules: '',
    type: 'currency',
    class: 'wala',
    disabled: true,
    cols: 2,
  },
  {
    key: 'meronBetTotal418',
    label: 'field.laoMeronBet',
    rules: '',
    type: 'currency',
    class: 'meron',
    disabled: true,
    cols: 2,
  },
  {
    key: 'meronBetTotal',
    label: 'field.totalMeronBet',
    rules: '',
    type: 'currency',
    class: 'meron',
    disabled: true,
    cols: 4,
  },
  {
    key: 'walaBetTotal418',
    label: 'field.laoWalaBet',
    rules: '',
    type: 'currency',
    class: 'wala',
    disabled: true,
    cols: 2,
  },
  {
    key: 'walaBetTotal',
    label: 'field.totalWalaBet',
    rules: '',
    type: 'currency',
    class: 'wala',
    disabled: true,
    cols: 4,
  },
  {
    key: 'radioAmountMeron',
    label: 'field.meronRatioAmount',
    rules: 'required|decimal:2|min_value:0',
    type: 'currency',
    class: 'meron',
    cols: 6,
  },
  // {
  //   key: 'radioAmountMeron',
  //   label: 'field.meronRatioAmount',
  //   rules: 'required|decimal:2|min_value:0',
  //   type: 'currency',
  //   class: 'meron',
  //   cols: 2,
  // },
  // {
  //   key: 'secondRadioAmountMeron',
  //   label: 'field.meronSecondRatioAmount',
  //   rules: 'required|decimal:2|min_value:0',
  //   type: 'currency',
  //   class: 'meron',
  //   cols: 2,
  // },
  // {
  //   key: 'secondLowerMeronPayout',
  //   label: 'field.secondLowerMeronPayout',
  //   rules: 'required|decimal:2|min_value:0',
  //   type: 'currency',
  //   class: 'meron',
  //   cols: 2,
  // },
  {
    key: 'radioAmountWala',
    label: 'field.walaRatioAmount',
    rules: 'required|decimal:2|min_value:0',
    type: 'currency',
    class: 'wala',
    cols: 6,
  },
  // {
  //   key: 'radioAmountWala',
  //   label: 'field.walaRatioAmount',
  //   rules: 'required|decimal:2|min_value:0',
  //   type: 'currency',
  //   class: 'wala',
  //   cols: 2,
  // },
  // {
  //   key: 'secondRadioAmountWala',
  //   label: 'field.walaSecondRatioAmount',
  //   rules: 'required|decimal:2|min_value:0',
  //   type: 'currency',
  //   class: 'wala',
  //   cols: 2,
  // },
  // {
  //   key: 'secondLowerWalaPayout',
  //   label: 'field.secondLowerWalaPayout',
  //   rules: 'required|decimal:2|min_value:0',
  //   type: 'currency',
  //   class: 'wala',
  //   cols: 2,
  // },
  {
    key: 'drawPayoutRatio',
    label: 'field.drawPayoutRatio',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'draw',
    cols: 2,
  },
  {
    key: 'drawPayoutRatioActionBefore',
    label: 'field.drawPayoutRatioActionBefore',
    rules: 'required|decimal:2|min_value:0',
    type: 'text',
    class: 'draw',
    cols: 2,
  },
  {
    key: 'drawBetTotal116',
    label: 'field.reilDrawBet',
    rules: '',
    type: 'text',
    class: 'draw',
    cols: 2,
    disabled: true,
  },
  {
    key: 'drawBetTotal840',
    label: 'field.dollarDrawBet',
    rules: '',
    type: 'text',
    class: 'draw',
    cols: 2,
    disabled: true,
  },
  {
    key: 'drawBetTotal764',
    label: 'field.thaiDrawBet',
    rules: '',
    type: 'text',
    class: 'draw',
    cols: 2,
    disabled: true,
  },
  {
    key: 'drawBetTotal418',
    label: 'field.laoDrawBet',
    rules: '',
    type: 'text',
    class: 'draw',
    cols: 2,
    disabled: true,
  },
  {
    key: 'drawBetTotal',
    label: 'field.totalDrawBet',
    rules: '',
    type: 'text',
    class: 'draw',
    cols: 2,
    disabled: true,
  },
  {
    cols: 12,
    hide: true,
    skip: true,
  },
  {
    key: 'fightDuration',
    label: 'field.statusDuration',
    rules: 'required|integer|min_value:0',
    type: 'text',
    cols: 6,
  },
  {
    key: 'suspendDurationMin',
    label: 'field.suspendDurationMin',
    rules: 'required|integer|min_value:0',
    type: 'text',
    cols: 6,
  },
]
